module.exports = __webpack_public_path__ + "img/inefop.3a2bccf1.png";